<template>
    <div>
        <answer-header type="back"></answer-header>
        <img class="logo" src="../assets/logo.png">
        <div class="blk2 questContainer" v-if="curQuestion">
            <div class="title">{{curIndex+1}}: {{curQuestion.title}}</div>
            <ul class="answer-list">
                <li v-for="(item, index) in curQuestion.options" :class="{'answer-item':true, 'answer-item-active':curQuestion.correctIndex==index}">
                    <em>{{index|answerName}}. </em>{{item}}
                </li>
            </ul>
        </div>
        <div class="anser-text questContainer" v-if="curQuestion">
            <p class="questContainerZ">ေျဖရွင္းခ်က္: </p>
            <p class="questContainer">{{curQuestion.remark}}</p>
        </div>
        <div class="blk3">
            <div :class="{'btn':true, 'btn-block':true}" @click="_NextQ">{{curIndex==list.length-1 ? 'အိုေက ' : ' အတည္ျပဳသည္'}}</div>
        </div>
    </div>
</template>
<script>
import answerHeader from './Header'
import { mapState, mapActions } from 'vuex'
import config from '../config'
var optionsMap = {'A':0, 'B':1, 'C':2, 'D':3};

export default {
    name: 'Answer',
    components: { answerHeader },
    data(){
        return {
            list: [],
            curIndex: null,
            questionId: this.$route.query.id
        }
    },
    filters: {
        answerName(num){
            let map = ['A', 'B', 'C', 'D'];
            return map[num];
        }
    },
    computed: {
        ...mapState(['lang','langMap']),
        curQuestion(){
            return this.list[this.curIndex]
        }
    },
    created(){
        this._fetchList();
    },
    methods: {
        _fetchList(){
            var id = this.$route.query.id;
            Utils.$ajax({
                type: 'post',
                url: '/core/learn',
                data: {id:this.questionId}
            }).done(res=>{
                if(res.code!=0){
                    this.$toast(res.msg);
                    return;
                }
                res.data.forEach(item=>{
                    item.options = item.options.split('|');
                    item.correctIndex = optionsMap[item.correct];
                })
                this.list = res.data;
                this.curIndex = 0;
            })
        },
        _NextQ(){
            if(this.curIndex == this.list.length -1){
                this.$router.go(-1);
                return;
            }
            this.curIndex ++;
        }
    }
}

</script>
<style lang="scss" scoped>
    .blk2{
        .title{
            font-size: rem(32);
        }
        .answer-list{
            margin-top: rem(50);
        }
        .answer-item{
            padding: rem(16) rem(30);
            border-radius: rem(45);
            background-color: #fff;
            font-size: rem(36);
            color: #000;
            margin-top: rem(30);
            em{
                font-size: rem(32);
                color: #555;
            }
            &:first-child{
                margin-top: 0;
            }
            &.answer-item-active{
               background-color: #ff50b3;
               color: #fff;
            }
        }
    }
    .anser-text{
        margin-top: rem(50);
        p{
            margin-top: rem(10);
        }
    }
    .blk3{
        margin-top: rem(50);
    }
</style>



// WEBPACK FOOTER //
// src/components/Review.vue